import _ from 'lodash'

export default class Column {
  id
  name
  isNew
  pinyinName
  pinyinFirstChar

  static create (args) {
    const column = new Column()
    column.isNew = true
    _.defaults(column, args)
    return column
  }

  static load (args) {
    const column = new Column()
    column.isNew = false
    _.defaults(column, args)
    return column
  }
}



// WEBPACK FOOTER //
// ./src/store/form/column.js